






















































































import { Vue, Component } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Logo from '@/components/layout/Logo.vue'
import NationalSelect from '@/components/exam/NationalSelect.vue'
import { ConfigStore } from '@/store/config'
import { createStudent } from '@/apis/student'
import { getKey } from '@/utils/key'
import { alert, confirm } from '@/utils/notification'
import { createValidator } from '@/utils/element'

@Component({
  components: { Logo, NationalSelect }
})
export default class Register extends Vue {
  getKey = getKey
  loading = false
  form = {
    idNumber: '',
    name: '',
    sex: null as number | null,
    birthday: null as Date | null,
    national: '',
    password: '',
    passwordAgain: '',
    resetPasswordQuestion: '',
    resetPasswordAnswer: '',
    contactAddress: '',
    contactPhone: '',
    telephone: '',
    zipCode: ''
  }

  rules = {
    idNumber: [
      { required: true, message: '请输入有效的身份证号码', trigger: 'change' },
      {
        // validator: createValidator(async (rule, value) => {
        //   if (!checkIDCard(value)) throw '请输入有效的身份证号码'
        // }),
        trigger: 'blur'
      }
    ],
    name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
    sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
    birthday: [
      {
        type: 'date',
        required: true,
        message: '请选择出生年月',
        trigger: 'change'
      }
    ],
    national: [{ required: true, message: '请选择民族', trigger: 'change' }],
    password: [
      { required: true, message: '请输入密码', trigger: 'change' },
      { min: 6, message: '至少需要设置 6 位密码', trigger: 'change' }
    ],
    passwordAgain: [
      { required: true, message: '请再次输入密码', trigger: 'change' },
      {
        validator: createValidator(async (rule, value) => {
          if (value !== this.form.password) throw '两次输入密码不一致'
        }),
        trigger: 'blur'
      }
    ],
    resetPasswordQuestion: [
      { required: true, message: '请选择密保问题', trigger: 'change' }
    ],
    resetPasswordAnswer: [
      { required: true, message: '请输入密保答案', trigger: 'change' }
    ]
  }

  get questions() {
    const configs = ConfigStore.configs
    const options =
      configs.find(a => a.key === 'resetPasswordQuestion')?.value ?? []
    return options
  }

  async handleRegister() {
    try {
      const form = this.$refs.form as ElForm
      await form.validate()
    } catch (e) {
      return
    }

    const birthday = this.form.birthday as Date
    const form = {
      ...this.form,
      sex: this.form.sex as number,
      birthYear: birthday.getFullYear().toString(),
      birthMonth: birthday.getMonth().toString()
    }

    try {
      this.loading = true
      await createStudent(form)
      await confirm('注册成功')
      this.$router.push('/')
    } catch (e) {
      alert('注册失败，请重试', e)
    } finally {
      this.loading = false
    }
  }

  handleReset() {
    const form = this.$refs.form as ElForm
    form.resetFields()
  }
}
